import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    FormControlLabel,
    Checkbox,
    ButtonGroup,
    Chip,
    Typography,
    Tooltip,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { Add, AddBox, Backspace, CheckBox, CheckBoxOutlineBlank, ChevronLeft, DatasetLinked, Delete, Edit, Functions, Info, RemoveCircle, Save, Search, Square, TurnLeft, VisibilityOff, WarningAmber } from '@mui/icons-material';

import { makeid, myTimestampToDate, propComparator } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { useAuth } from '../core/AuthProvider';
import { DateTimePicker } from '@mui/x-date-pickers';
import { useEvent } from '../context/eventContext';
import { addDays, addMinutes, differenceInCalendarDays, format } from 'date-fns';
import { AwardDialog } from './AwardDialog';
import { globalstyles } from '../lib/definitions';
import { AwardLabelDialog } from './AwardLabelDialog';
import { MatchSourceDialog } from './MatchSourceDialog';
import { award_filter_subdict } from '../definitions/match';
import TemplateMenu from '../components/menu/TemplateMenu';
import { add_award_label_template, add_award_template, add_match_template, get_award_label_template_list, get_award_template_list, get_match_template_list } from '../FirebaseUtils/dbSettings';
import { MatchDynamicSourceDialog } from './MatchDynamicSourceSectionDialog';
import { NumberInput } from '../components/NumberInput';
import { MyInput } from '../components/MyInput';



export const newmatch = {
    match_name: '',
    match_shortname: '',
    export_position_limit: 0,
    match_description: '',
    match_type: 'normal',
    cow_list: [],
    award_list: [],
    has_partial: false,
    is_public: true,
    planned_start: new Date()
}


const match_type_list = [
    { id: 'normal', label: 'manuale' },
    { id: 'auto', label: 'automatica' }
]




export const MatchDialog = forwardRef(({ addFn, editFn, element_list, category_list }, ref) => {
    const [open, setOpen] = useState(false);
    const { selEvent } = useEvent()
    const { user } = useAuth()
    const [curElement, setCurElement] = useState({ ...newmatch })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [multiEdit, setMultiEdit] = useState(false)

    const list_insert_mode = [
        { id: 'static', label: 'solo manuale', checkCondition: (e) => !e.link_to_category && !e.use_dynamic_list },
        { id: 'dynamic', disabled: (element_list === undefined || element_list.length === 0), label: 'dinamica', description: 'da altre gare', checkCondition: (e) => !e.link_to_category && e.use_dynamic_list === true },
        { id: 'linked_category', label: 'collegata a categoria', checkCondition: (e) => e.link_to_category === true && !e.use_dynamic_list },
    ]


    const _award_filter_subdict = {
        ...award_filter_subdict,
        ...selEvent.custom_cow_filter_param_list ? Object.assign({}, ...selEvent.custom_cow_filter_param_list.map(x => ({ [x.param_name]: { id: x.param_name, label: x.param_name, color: 'info' } }))) : {}
    }

    useImperativeHandle(ref, () => {
        return {
            onNew(planned_start, k) {
                let newStart = myTimestampToDate(selEvent.event_start)
                if (planned_start) {
                    console.log("FROM PREVIUS")
                    newStart = planned_start
                }
                setCurElement({ ...newmatch, planned_start: newStart })
                setIndex(k || -1)
                setIsNew(true)
                setIsEdited(false)
                setMultiEdit(false)
                setOpen(true);
            },
            onEdit(el, i) {
                setOpen(true);
                setIsNew(false)
                setMultiEdit(Array.isArray(i))
                let _el = { ...newmatch, ...el }
                setCurElement(_el)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };


    const handleSave = (force) => {
        console.log("SAVE", curElement)
        if (is_new || force === true) {
            addFn(curElement, -1)
        } else {
            if (multiEdit) {
                let _el = { ...curElement }
                delete _el.match_description
                delete _el.match_name
                delete _el.planned_start
                delete _el.cow_list
                delete _el.linked_category
                delete _el.id
                editFn(_el, index)
            } else {
                editFn(curElement, index)

            }
        }
        setOpen(false)
    }



    const onChangeHandler = (el, is_multi) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (is_multi) {
            setCurElement({ ...curElement, ...el })
            setIsEdited(true)

        } else {

            if (type === 'radio') {
                if (value === 'true') {
                    value = true
                } else if (value === 'false') {
                    value = false
                }
            } else if (type === 'checkbox') {
                value = el.checked
            } else if (type === 'number') {
                value = parseInt(value)
            }

            if (value !== undefined) {
                setCurElement({ ...curElement, [name]: value })
                setIsEdited(true)
            }
        }
    }

    const toggleMatchType = (t) => {
        if (t === 'normal') {
            setCurElement({ ...curElement, match_type: t })
        } else {
            setCurElement({ ...curElement, match_type: t, use_dynamic_list: true, link_to_category: false })
        }
        setIsEdited(true)

    }


    const toggleInsertMode = (t) => {
        if (t === 'static') {
            setCurElement({ ...curElement, use_dynamic_list: false, link_to_category: false })
        } else if (t === 'dynamic') {
            setCurElement({ ...curElement, use_dynamic_list: true, link_to_category: false })
        } else {
            setCurElement({ ...curElement, use_dynamic_list: false, link_to_category: true })
        }
        setIsEdited(true)
    }




    const isInvalid = () => {
        if (!multiEdit && curElement.match_name.length === 0) {
            console.log("MISSING NAME")
            return true
        }
        return false
    }

    const loadDataFromTemplate = (t) => {
        console.log("LOAD", t)
        onChangeHandler({
            award_list: t.value.award_list,
            award_label_list: t.value.award_label_list,
        }, true)
    }
    const load_listFn = async () => {
        const res = await get_match_template_list()
        return res.sort(propComparator('name'))
    }


    const saveMatchConfigAsTemplate = (nm) => {
        console.log("SAVE TMPL match")
        add_match_template(user.uid, {
            name: nm, 
            value: {
                award_list: curElement.award_list,
                award_label_list: curElement.award_label_list
            }
        })
    }


    const resetStatus = () => {
        setCurElement(m => {
            let _m = { ...m }
            _m.result_list = []
            delete _m.status
            console.log("RESET STATUS", _m)
            return _m
        })
        setIsEdited(true)

    }



    const resetCowlist = () => {
        setCurElement(m => {
            let _m = { ...m }
            _m.cow_list = []
            return _m
        })
    }

    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    Dati Gara:
                    {multiEdit ?
                        <i>(modifica multipla: {index.length})</i>
                        :
                        <b>{curElement.match_name}</b>
                    }
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        {!multiEdit &&
                            <>
                                <MyInput
                                    id="match_name"
                                    label={'Nome'}
                                    value={curElement.match_name}
                                    onChange={(ev) => onChangeHandler(ev.target)}
                                />
                                <MyInput
                                    id="match_shortname"
                                    label={'Nome ridotto (esportazione)'}
                                    value={curElement.match_shortname}
                                    onChange={(ev) => onChangeHandler(ev.target)}
                                />
                                <MyInput
                                    id="match_description"
                                    label={'Descrizione'}
                                    value={curElement.match_description}
                                    onChange={(ev) => onChangeHandler(ev.target)}
                                />

                                <Box>
                                    <Grid xs={6} container alignItems={"end"} alignContent={"center"}>
                                        <DateTimePicker
                                            variant="outlined"
                                            size="small"
                                            sx={{ mt: 0.8 }}
                                            label={'inizio previsto'}
                                            name={'planned_start'}
                                            id={'planned_start'}
                                            slotProps={{ field: { size: 'small' } }}
                                            value={myTimestampToDate(curElement.planned_start)}
                                            onChange={(nv) => onChangeHandler({ value: nv, name: 'planned_start' })} />
                                        <EventDateList setMatchDay={(d) => onChangeHandler({ value: d, name: 'planned_start' })} />
                                    </Grid>
                                </Box>
                                <Grid container sx={{ mt: 1 }}>
                                    <Grid size="auto" sx={globalstyles.input_label}>
                                        Assegnazione premi
                                    </Grid>
                                    <ButtonGroup size="small">
                                        {match_type_list.map((i, k) => (
                                            <Button key={k} size="small" variant={curElement.match_type === i.id ? 'contained' : 'outlined'} onClick={() => toggleMatchType(i.id)}>
                                                <div>
                                                    <Box>{i.label}</Box>
                                                    {i.description && <><Box sx={{ fontSize: '0.9em', mt: -1 }}>{i.description}</Box></>}

                                                </div>
                                            </Button>
                                        ))}
                                    </ButtonGroup>
                                </Grid>

                                <Grid container sx={{ mt: 1 }}>
                                    <Grid size="auto" sx={globalstyles.input_label}>
                                        Lista soggetti
                                    </Grid>
                                    <ButtonGroup size="small">
                                        {list_insert_mode.map((i, k) => (
                                            <Button disabled={i.disabled} key={k} size="small" variant={i.checkCondition(curElement) ? 'contained' : 'outlined'} onClick={() => toggleInsertMode(i.id)}>
                                                <div>
                                                    <Box>{i.label}</Box>
                                                    {i.description && <><Box sx={{ fontSize: '0.9em', mt: -1 }}>{i.description}</Box></>}

                                                </div>
                                            </Button>
                                        ))}
                                    </ButtonGroup>
                                </Grid>

                                {curElement.use_dynamic_list &&
                                    <DynamicListSection curElement={curElement} onChangeHandler={onChangeHandler} element_list={element_list} _award_filter_subdict={_award_filter_subdict} />
                                }
                                {curElement.link_to_category &&
                                    <CategoryListSection curElement={curElement} onChangeHandler={onChangeHandler} element_list={category_list} _award_filter_subdict={_award_filter_subdict} />
                                }
                            </>
                        }
                        <Box sx={{ textAlign: 'right', mt: 1 }} >
                            <TemplateMenu label={"template premi gara"} saveAs={saveMatchConfigAsTemplate} loadTemplate={loadDataFromTemplate} load_listFn={load_listFn} element_name="premi gara" />
                        </Box>
                        <AwardSection curElement={curElement} onChangeHandler={onChangeHandler} _award_filter_subdict={_award_filter_subdict} />
                        {curElement.award_list.filter(t => t.has_position).length > 0 &&

                            <AwardLabelSection curElement={curElement} onChangeHandler={onChangeHandler} />
                        }
                        <Box>
                            <FormControlLabel
                                control={<Checkbox checked={curElement.is_public === true} name="is_public" color="primary" onChange={(ev) => onChangeHandler(ev.target)} />}
                                label="Gara pubblica (visibile)"
                            />
                        </Box>
                        {curElement.is_public &&
                            <>
                                <Box>
                                    <FormControlLabel
                                        control={<Checkbox checked={curElement.public_partial_source === true} name="public_partial_source" color="primary" onChange={(ev) => onChangeHandler(ev.target)} />}
                                        label="Dati parziali pubblici"
                                    />
                                </Box>
                            </>}
                        <Box>
                            <FormControlLabel
                                control={<Checkbox checked={curElement.hide_not_qualified === true} name="hide_not_qualified" color="primary" onChange={(ev) => onChangeHandler(ev.target)} />}
                                label="Nascondi soggetti senza premi nel report giudizi"
                            />
                        </Box>
                        <Box sx={{ mb: 1 }}>
                            <NumberInput
                                value={curElement.export_position_limit || 0}
                                label={'Numero massimo posizioni esportate'}
                                name="export_position_limit"
                                onChangeHandler={onChangeHandler}
                                setCurElement={setCurElement}
                                setIsEdited={setIsEdited}
                            />
                        </Box>
                        <Box>
                            <FormControlLabel
                                control={<Checkbox checked={curElement.overflow_as_limit === true} name="overflow_as_limit" color="primary" onChange={(ev) => onChangeHandler(ev.target)} />}
                                label={`esporta soggetti oltre il limite e assegna la posizione ${curElement.export_position_limit || 0}`}
                                />
                        </Box>
                        {curElement.status &&
                            <>
                                <Button onClick={resetStatus} variant="outlined" color="error" startIcon={<Backspace />}>
                                    RESETTA STATO GARA
                                </Button>
                            </>}
                        {curElement.cow_list.length > 0 &&
                            <Button onClick={resetCowlist} variant="outlined" color="error" startIcon={<Backspace />}>
                                Resetta soggetti confermati in gara
                            </Button>
                        }
                        <LinkedMatchSection element_list={element_list} id={curElement.id} />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={isInvalid()} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">Salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})



const EventDateList = ({ setMatchDay }) => {
    const { selEvent } = useEvent()

    const startDate = myTimestampToDate(selEvent.event_start)
    const d = differenceInCalendarDays(myTimestampToDate(selEvent.event_end), startDate)
    const date_list = []
    for (let cd = 0; cd <= d; cd++) {
        date_list.push(addDays(startDate, cd))
    }

    if (date_list.length > 1) {
        return (
            <ButtonGroup sx={{ ml: 2 }}>
                {date_list.map((d, k) => (
                    <Button
                        key={k}
                        color="secondary"
                        startIcon={<TurnLeft />}
                        onClick={() => setMatchDay(d)}>
                        {format(d, 'dd/MM')}
                    </Button>
                ))}
            </ButtonGroup>
        )

    } else {
        return <></>
    }
}



//----------------------CATEGORY LIST-------------------------------
const CategoryListSection = ({ curElement, onChangeHandler, element_list, _award_filter_subdict }) => {
    const dialogRef = useRef()
    const edit_source = (value, a, e) => {
        let _list = curElement.linked_category ? { ...curElement.linked_category } : {}
        _list[a][e] = value
        onChangeHandler({ name: 'linked_category', value: _list })

    }

    const togglePresence = (c) => {
        if (curElement.linked_category && curElement.linked_category.id === c.id) {
            onChangeHandler({ name: 'linked_category', value: {} })
        } else {
            onChangeHandler({ name: 'linked_category', value: { category_name: c.category_name, category_description: c.category_description, id: c.id } })
        }
    }






    const DialogContent = () => {

        return (

            <>
                <Grid container sx={globalstyles.listHeader}>
                    <Grid size={1}>
                    </Grid>
                    <Grid size={2}>
                        nome categoria
                    </Grid>
                    <Grid size={"grow"}>
                        descrizione
                    </Grid>
                </Grid>
                {element_list?.filter(e =>
                    e.id !== curElement.id
                ).map((c, k) => (
                    <Grid key={k} container sx={globalstyles.list_row}>
                        <Grid size={1}>

                            {curElement.linked_category && curElement.linked_category.id === c.id ?

                                <Button onClick={() => togglePresence(c)}><CheckBox /></Button>
                                :
                                <Button onClick={() => togglePresence(c)}><CheckBoxOutlineBlank /></Button>
                            }

                        </Grid>
                        <Grid size={2}>
                            {c.category_name}
                        </Grid>
                        <Grid size="grow" sx={{ fontSize: '0.8em' }}>
                            {c.category_description}
                        </Grid>
                    </Grid>
                ))}
            </>
        )
    }


    return (
        <Grid sx={globalstyles.list_container}>
            <MatchSourceDialog ref={dialogRef} edit_fn={edit_source} _award_filter_subdict={_award_filter_subdict} />
            <Grid container sx={globalstyles.sectionHeader}>
                <Grid size={"grow"}>
                    Categoria collegata a questa gara
                </Grid>
                <Grid>

                    <MatchDynamicSourceDialog button_label={"modifica"} MyContent={DialogContent} />
                </Grid>
            </Grid>
            {!curElement.linked_category || !curElement.linked_category.id
                ?
                <Box sx={globalstyles.missing_value}>
                    <WarningAmber /> nessuna categoria selezionata
                </Box>
                :
                <>
                    <Grid>
                        <Grid size={3} sx={{ fontWeight: 'bold', }}>
                            {curElement.linked_category.category_name}
                        </Grid>
                        <Grid>
                            {curElement.linked_category.category_description}
                        </Grid>
                    </Grid>
                </>}

        </Grid>
    )
}




//----------------------DYNAMIC LIST-------------------------------
const DynamicListSection = ({ curElement, onChangeHandler, element_list, _award_filter_subdict }) => {
    const dialogRef = useRef()
    const [showEdit, setShowEdit] = useState(false)



    const handleAdd = (a, e, index) => {
        let _list = curElement.source_list_data ? { ...curElement.source_list_data } : {}
        _list[a.id][e.id] = { use_value: true }
        onChangeHandler({ name: 'source_list_data', value: _list })
    }
    const handleEdit = (a, e, index) => {
        let _data = {}
        if (curElement.source_list_data && curElement.source_list_data[a.id] && curElement.source_list_data[a.id][e.id]) {
            _data = curElement.source_list_data[a.id][e.id]
        }
        dialogRef.current.onEdit(_data, index, a, e)
    }
    const handleDelete = (a, e, index) => {
        let _list = curElement.source_list_data ? { ...curElement.source_list_data } : {}
        delete _list[a.id][e.id]
        onChangeHandler({ name: 'source_list_data', value: _list })
    }

    const add_source = (e) => {
        let _list = curElement.source_list_data ? { ...curElement.source_list_data } : {}
        _list[e] = {}
        onChangeHandler({ name: 'source_list_data', value: _list })
    }


    const edit_source = (value, a, e) => {
        let _list = curElement.source_list_data ? { ...curElement.source_list_data } : {}
        _list[a][e] = value
        onChangeHandler({ name: 'source_list_data', value: _list })

    }
    const remove_source = (el) => {
        let _label_list_data = { ...curElement.source_list_data }
        delete _label_list_data[el]
        onChangeHandler({ name: 'source_list_data', value: _label_list_data })
    }



    const handleClean = () => {
        onChangeHandler({ name: 'source_list_data', value: {} })
    }

    const DialogContent = () => {
        return (
            <>
                <Grid container sx={globalstyles.listHeader}>
                    <Grid size={1}>
                    </Grid>
                    <Grid size={3}>
                        nome gara
                    </Grid>
                    {curElement.match_type === 'normal' &&
                        <>
                            <Grid size={3}>
                                premi
                            </Grid>
                            <Grid size={3}>
                                soggetti
                            </Grid>
                        </>
                    }
                </Grid>
                {console.log("EL", element_list)}
                {element_list?.filter(e =>
                    e.id !== curElement.id
                ).map((a, k) => (
                    <Grid key={k} container sx={globalstyles.list_row}>
                        <Grid size={1}>
                            <ButtonGroup size="small">

                                {a.award_list && a.award_list.length > 0 ?
                                    <>
                                        {!curElement.source_list_data || !curElement.source_list_data[a.id] ?
                                            <Button disabled={!a.award_list || a.award_list.length === 0 || curElement.source_list_data && curElement.source_list_data[a.id]} onClick={() => add_source(a.id)}><CheckBoxOutlineBlank /></Button>
                                            :
                                            <Button color={curElement.match_type === 'auto' || Object.keys(curElement.source_list_data[a.id]).length > 0 ? 'success' : 'warning'} disabled={!a.award_list || a.award_list.length === 0 || !curElement.source_list_data || !curElement.source_list_data[a.id]} onClick={() => remove_source(a.id)}><CheckBox /></Button>
                                        }
                                    </>
                                    : <></>
                                }
                            </ButtonGroup>
                        </Grid>
                        <Grid size={curElement.match_type === 'normal' ? 3 : 'grow'} sx={{ fontWeight: 'bold', color: curElement.source_list_data && curElement.source_list_data[a.id] ? 'black' : 'grey' }}>
                            {a.match_name}
                            <Typography sx={{ fontSize: '0.6em' }}>
                                {a.match_description}
                            </Typography>
                        </Grid>
                        {(a.award_list === undefined || a.award_list.length === 0) &&
                            <Grid size="grow" sx={{ fontSize: '0.6em', textAlign: 'center' }}>
                                gara senza premi
                            </Grid>

                        }
                        {curElement.match_type === 'normal' &&
                            <>
                                {curElement.source_list_data && curElement.source_list_data[a.id] &&
                                    <Grid size="grow">

                                        {a.award_list?.map((aw, ka) => (
                                            <Grid key={ka} container sx={globalstyles.list_row}>
                                                <Grid size={6} sx={{ color: curElement.source_list_data[a.id][aw.id] ? 'black' : 'lightgrey' }}>
                                                    {aw.award_name}
                                                </Grid>
                                                <Grid size={'grow'}>
                                                    {curElement.source_list_data[a.id][aw.id]?.filter_applied ? <Chip size="small" color={_award_filter_subdict[curElement.source_list_data[a.id][aw.id].filter_applied]?.color} label={_award_filter_subdict[curElement.source_list_data[a.id][aw.id].filter_applied]?.label} /> : ''}
                                                </Grid>
                                                <Grid size={"grow"}>
                                                    {aw.has_position ?
                                                        <>
                                                            {curElement.source_list_data[a.id][aw.id]?.position_list?.map((p, k) => <Chip color="primary" size="small" key={k} label={p} />)}
                                                        </>
                                                        :
                                                        curElement.source_list_data[a.id][aw.id] && <CheckBox />
                                                    }
                                                </Grid>
                                                <Grid size={3} sx={{ textAlign: 'right' }}>
                                                    {curElement.source_list_data[a.id][aw.id] ?
                                                        <>

                                                            <ButtonGroup size="small">
                                                                {aw.has_position &&
                                                                    <Button color="warning" onClick={() => handleEdit(a, aw, ka)} startIcon={<Edit />}></Button>
                                                                }
                                                                <Button color="error" onClick={() => handleDelete(a, aw, ka)} startIcon={<Delete />}></Button>
                                                            </ButtonGroup>
                                                        </>
                                                        :
                                                        <>
                                                            {aw.has_position ?
                                                                <Button variant="outlined" size="small" color="primary" onClick={() => handleEdit(a, aw, ka)} startIcon={<AddBox />}>P</Button>
                                                                :
                                                                <Button variant="outlined" size="small" color="primary" onClick={() => handleAdd(a, aw, ka)} startIcon={<AddBox />}></Button>
                                                            }
                                                        </>}


                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                }
                            </>}
                    </Grid>
                ))}
            </>
        )
    }

    return (
        <Grid sx={globalstyles.list_container}>
            <MatchSourceDialog ref={dialogRef} edit_fn={edit_source} _award_filter_subdict={_award_filter_subdict} />
            <Grid container sx={globalstyles.sectionHeader}>
                <Grid size={"grow"}>
                    Regole crezione lista soggetti dinamica
                </Grid>
                <Grid>
                    {curElement.source_list_data &&
                        <Button onClick={handleClean} size="small" variant="contained" color="error" startIcon={<Delete />}>Pulisci lista ({Object.keys(curElement.source_list_data).length})</Button>
                    }
                    <MatchDynamicSourceDialog button_label={"modifica"} MyContent={DialogContent} title={`gare sorgenti per ${curElement.match_name}`} />
                </Grid>
            </Grid>
            {element_list?.filter(e =>
                curElement.source_list_data && curElement.source_list_data[e.id]).length === 0 ?
                <Box sx={globalstyles.missing_value}>
                    <WarningAmber />  Nessuna gara selezionata
                </Box>
                :
                <>
                    <Grid container sx={globalstyles.listHeader}>
                        <Grid size={3}>
                            nome gara
                        </Grid>
                        {curElement.match_type === 'normal' &&
                            <>
                                <Grid size={"grow"}>
                                    premi
                                </Grid>
                                <Grid size={"grow"}>
                                    soggetti
                                </Grid>
                            </>
                        }
                    </Grid>
                    {element_list?.filter(e =>
                        curElement.source_list_data && curElement.source_list_data[e.id]
                    ).map((a, k) => (
                        <Grid key={k} container sx={globalstyles.list_row}>
                            <Grid size={3} sx={{ fontWeight: 'bold', color: curElement.source_list_data && curElement.source_list_data[a.id] ? 'black' : 'grey' }}>
                                {a.match_name}
                            </Grid>
                            {curElement.source_list_data && curElement.source_list_data[a.id] &&
                                <Grid size="grow">
                                    {a.award_list?.filter(aw => showEdit || curElement.source_list_data[a.id][aw.id]).map((aw, ka) => (
                                        <Grid key={ka} container sx={globalstyles.elem_row}>
                                            <Grid size={6} sx={{ color: curElement.source_list_data[a.id][aw.id] ? 'black' : 'lightgrey' }}>
                                                {aw.award_name}
                                            </Grid>
                                            <Grid size={'grow'}>
                                                {curElement.source_list_data[a.id][aw.id]?.filter_applied ? <Chip size="small" color={_award_filter_subdict[curElement.source_list_data[a.id][aw.id].filter_applied].color} label={_award_filter_subdict[curElement.source_list_data[a.id][aw.id].filter_applied].label} /> : ''}
                                            </Grid>
                                            <Grid size={"grow"}>
                                                {aw.has_position ?
                                                    <>
                                                        {curElement.source_list_data[a.id][aw.id]?.position_list?.map((p, k) => <Chip color="primary" size="small" key={k} label={p} />)}
                                                    </>
                                                    :
                                                    curElement.source_list_data[a.id][aw.id] && <CheckBox />
                                                }
                                            </Grid>
                                            <Grid size={3} sx={{ textAlign: 'right' }}>
                                                {curElement.source_list_data[a.id][aw.id] ?
                                                    <>

                                                        {showEdit &&
                                                            <ButtonGroup size="small">
                                                                {aw.has_position &&
                                                                    <Button color="warning" onClick={() => handleEdit(a, aw, ka)} startIcon={<Edit />}></Button>
                                                                }
                                                                <Button color="error" onClick={() => handleDelete(a, aw, ka)} startIcon={<Delete />}></Button>
                                                            </ButtonGroup>
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        {aw.has_position ?
                                                            <Button variant="outlined" size="small" color="primary" onClick={() => handleEdit(a, aw, ka)} startIcon={<AddBox />}>P</Button>
                                                            :
                                                            <Button variant="outlined" size="small" color="primary" onClick={() => handleAdd(a, aw, ka)} startIcon={<AddBox />}></Button>
                                                        }
                                                    </>}


                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            }
                        </Grid>
                    ))}
                </>
            }

        </Grid>
    )
}



const AwardSection = ({ curElement, onChangeHandler, _award_filter_subdict }) => {
    const { selEvent } = useEvent()
    const modalRef = useRef()
    const { user } = useAuth()
    const handleNew = () => {
        modalRef.current.onNew(curElement.award_list)
    }
    const handleEdit = (el, k) => {
        modalRef.current.onEdit(el, k)
    }

    const add_Award = (e) => {
        let _list = curElement.award_list ? [...curElement.award_list] : []
        _list.push(e)
        onChangeHandler({ name: 'award_list', value: _list })
    }

    const edit_Award = (e, index) => {
        let _list = curElement.award_list ? [...curElement.award_list] : []
        _list.splice(index, 1, e)
        onChangeHandler({ name: 'award_list', value: _list })

    }
    const handleDelete = (el, k) => {
        let _label_list = curElement.award_list ? [...curElement.award_list] : []
        _label_list.splice(k, 1)
        onChangeHandler({ name: 'award_list', value: _label_list })
    }

    const saveAwardlistAsTemplate = (nm) => {
        console.log("SAVE TMPL AWARD")

        add_award_template(user.uid, { name: nm, value: curElement.award_list })
    }
    const loadListFromTemplate = (t) => {
        console.log("LOAD", t)
        onChangeHandler({ name: 'award_list', value: t.value })

    }


    const load_listFn = async () => {
        const res = await get_award_template_list()
        return res.sort(propComparator('name'))
    }

    return (
        <Grid sx={globalstyles.list_container}>
            <AwardDialog ref={modalRef} add_Award={add_Award} edit_Award={edit_Award} custom_filter={selEvent.custom_cow_filter_param_list} />
            <Grid container sx={globalstyles.sectionHeader}>

                <Grid size={"grow"}>
                    Lista premi assegnabili
                </Grid>
                <Grid size={"auto"}>
                    <ButtonGroup>
                        <Button variant="contained" size="small" onClick={handleNew} startIcon={<AddBox />}>Nuovo premio</Button>
                        <TemplateMenu saveAs={curElement.award_list.length > 0 && saveAwardlistAsTemplate} loadTemplate={loadListFromTemplate} load_listFn={load_listFn} element_name="premi assegnabili" />
                    </ButtonGroup>
                </Grid>
            </Grid>
            {!curElement.award_list || curElement.award_list.length === 0 ?
                <i>Nessun premio inserito</i>
                :
                <>
                    <Grid container sx={globalstyles.listHeader}>
                        <Grid size={"grow"}>
                            nome
                        </Grid>
                        <Grid size={"grow"}>
                            usa posizione
                        </Grid>
                        <Grid size={"grow"}>
                            punti assegnati
                        </Grid>
                        <Grid size={"grow"}>
                            filtro
                        </Grid>
                        <Grid size={1.3}>
                        </Grid>
                    </Grid>
                    {curElement.award_list?.map((a, k) => (
                        <Grid key={k} container sx={globalstyles.list_row}>
                            <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                                {a.award_name}
                                {a.from_other_data &&
                                    <Tooltip title="da dati esterni">
                                        {a.groupby && a.groupby.length > 0 ?
                                            <Functions style={{ fontSize: '1em' }} />
                                            :
                                            <DatasetLinked style={{ fontSize: '1em' }} />
                                        }
                                    </Tooltip>
                                }
                                {a.hide_from_screen &&
                                    <Tooltip title="nascondi su schermo esterno">
                                        <VisibilityOff style={{ fontSize: '1em', color: 'orange' }} />
                                    </Tooltip>
                                }
                                <span style={{ fontWeight: 'normal' }}>

                                    {a.limit_count}
                                </span>
                            </Grid>
                            <Grid size={"grow"}>
                                {a.has_position &&
                                    <>
                                        <CheckBox />
                                    </>}
                            </Grid>
                            <Grid size={"grow"}>
                                {a.point_list?.map((p, kk) => (
                                    <Chip key={kk} size="small" label={p} />
                                ))}
                            </Grid>
                            <Grid size={"grow"}>
                                {a.filter_data_list?.map((f, k) => (
                                    <Chip key={k} label={_award_filter_subdict[f]?.label} color={_award_filter_subdict[f]?.color} size="small" />
                                ))}
                            </Grid>
                            <Grid size={1.3}>
                                <ButtonGroup size="small">
                                    <Button color="warning" onClick={() => handleEdit(a, k)} startIcon={<Edit />}></Button>
                                    <Button color="error" onClick={() => handleDelete(a, k)} startIcon={<Delete />}></Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    ))}
                </>
            }

        </Grid>
    )
}

const AwardLabelSection = ({ curElement, onChangeHandler }) => {
    const modalRef = useRef()
    const { user } = useAuth()

    const handleNew = () => {
        modalRef.current.onNew(curElement.award_label_list)
    }
    const handleEdit = (el, k) => {
        modalRef.current.onEdit(el, k)
    }
    const handleDelete = (el, k) => {
        let _label_list = curElement.award_label_list ? [...curElement.award_label_list] : []
        _label_list.splice(k, 1)
        onChangeHandler({ name: 'award_label_list', value: _label_list })
    }

    const add_Award = (e) => {
        let _label_list = curElement.award_label_list ? [...curElement.award_label_list] : []
        _label_list.push(e)
        onChangeHandler({ name: 'award_label_list', value: _label_list })
    }

    const edit_Award = (e, index) => {
        let _label_list = curElement.award_label_list ? [...curElement.award_label_list] : []
        _label_list.splice(index, 1, e)
        onChangeHandler({ name: 'award_label_list', value: _label_list })

    }


    const saveAwardlistAsTemplate = (nm) => {
        console.log("SAVE TMPL AWARD")

        add_award_label_template(user.uid, { name: nm, value: curElement.award_label_list })
    }
    const loadListFromTemplate = (t) => {
        console.log("LOAD", t)
        onChangeHandler({ name: 'award_label_list', value: t.value })

    }


    const load_listFn = async () => {
        const res = await get_award_label_template_list()
        return res.sort(propComparator('name'))
    }


    return (
        <Grid sx={globalstyles.list_container}>
            <AwardLabelDialog ref={modalRef} add_Award={add_Award} edit_Award={edit_Award} />
            <Grid container sx={globalstyles.sectionHeader}>
                <Grid size={"grow"}>
                    Lista etichette premi (posizione)
                </Grid>
                <Grid size={"auto"}>
                    <ButtonGroup>
                        <Button variant="contained" size="small" onClick={handleNew} startIcon={<AddBox />}>Nuova Etichetta</Button>
                        <TemplateMenu saveAs={curElement.award_label_list?.length > 0 && saveAwardlistAsTemplate} loadTemplate={loadListFromTemplate} load_listFn={load_listFn} element_name="etichette premi" />
                    </ButtonGroup>
                </Grid>
            </Grid>
            {!curElement.award_label_list || curElement.award_label_list.length === 0 ?
                <i>Nessuna etichetta inserita</i>
                :
                <>
                    <Grid container sx={globalstyles.listHeader}>
                        <Grid size={3}>
                            nome
                        </Grid>
                        <Grid size={1}>
                            nome ridotto
                        </Grid>
                        <Grid size={3}>
                            posizione
                        </Grid>
                        <Grid size={3}>
                        </Grid>
                    </Grid>
                    {curElement.award_label_list?.map((a, k) => (
                        <Grid key={k} container sx={globalstyles.list_row}>
                            <Grid size={3}>
                                {a.award_name}
                            </Grid>
                            <Grid size={1}>
                                {a.award_shortname}
                            </Grid>
                            <Grid size={3}>
                                {a.position}
                            </Grid>
                            <Grid size={3}>
                                <ButtonGroup size="small">
                                    <Button color="warning" onClick={() => handleEdit(a, k)} startIcon={<Edit />}></Button>
                                    <Button color="error" onClick={() => handleDelete(a, k)} startIcon={<Delete />}></Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    ))}
                </>
            }

        </Grid>
    )
}



const LinkedMatchSection = ({ element_list, id }) => {
    const lm = element_list.filter(m => m.source_list_data && m.source_list_data[id])

    return (
        <>
            <Grid sx={globalstyles.list_container}>
                <Grid container sx={globalstyles.sectionHeader}>
                    <Grid size={"grow"}>
                        <Info sx={{ fontSize: '1em' }} /> Gare collegate a questa gara
                    </Grid>
                </Grid>
                {lm.length > 0 ?
                    <>
                        {lm.map((m, k) => (
                            <Grid sx={globalstyles.list_row} key={k}>
                                <Grid sx={{ fontSize: '12px' }}>
                                    {m.match_name}
                                </Grid>
                            </Grid>
                        ))}
                    </>
                    : <>
                        nessuna gara collegata
                    </>}
            </Grid>
        </>
    )
}